import { callGet, callPost, callPutById, callDelete } from "../integrations/calls";


import { REQ } from "../../libs/constants";


export const getAllBookings = async(token) => {
    return await callGet(`${REQ.BOOKING.GET_ALL_Booking}`, token)
}

export const createBooking = async (data, token) => {
    return await callPost(REQ.BOOKING.ADD_BOOKING, data, token);
};


export const updateSingleAccount = async (data, token) => {
    return await callPutById(`${REQ.BOOKING.UPDATE_ACCOUNT}/${data.BookingID}`, data, token);
};

export const deleteSingleAccount = async (data, token) => {
    return await callDelete(`${REQ.BOOKING.DELETE_ACCOUNT}/${data.BookingID}`, data, token);
};

export const getSingleParty = async(id, token) => {
    return await callGet(`${REQ.PARTY.GET_SINGLE_ACCOUNT}/${id}`, token)
}